import { useState } from "react";
import ReviewForm from "../components/ReviewForm";
import ReviewList from "../components/ReviewList";

export default function Review() {
  const [newReview, setNewReview] = useState(null);

  return (
    // bg-gray-50
    <div className="min-h-screen px-4 py-10  justify-evenly block md:flex bg-[radial-gradient(80%_60%_at_20%_10%,rgba(255,0,128,0.18),transparent_60%),radial-gradient(70%_50%_at_80%_0%,rgba(56,189,248,0.18),transparent_60%),radial-gradient(60%_60%_at_50%_100%,rgba(250,204,21,0.18),transparent_60%)]">
      

      {/* Review form */}
      <div className="block mb-10">
        <h3 style={{ fontSize: "2.5rem" }} className="text-center h-[50px]  mt-3 bg-gradient-to-r from-fuchsia-600 via-sky-600 to-amber-600 bg-clip-text text-lg font-extrabold tracking-tight text-transparent text-[#d946ef]">
            Review
          </h3>
        <ReviewForm onReviewAdded={(review) => setNewReview(review)} />
      </div>

      {/* Review list */}
      <div className="w-[100%] md:w-[30%]  ">
        <ReviewList newReview={newReview} />
      </div>
    </div>
  );
}



